import { Box, FormHelperText, MenuItem, Select, useTheme } from "@mui/material";
import React from "react";
import { FormLabel } from "../FormInput/FormLabel";
import { FormSelectProps } from "./FormSelect.types";
import { customInputSxProps } from "../FormInput";

const FormSelect = React.forwardRef<HTMLInputElement, FormSelectProps>(({ onChange, fullWidth = true, multiple, width = "15.625rem", options, value, label, helperText, disabled, required }, ref): JSX.Element => {
  const error = !!helperText;
  const theme = useTheme();

  return (
    <Box sx={{ width: fullWidth ? "100%" : width }}>
      {label && <FormLabel label={label} error={error} required={required} />}
      <Select
        ref={ref}
        error={error}
        fullWidth
        multiple={multiple}
        disabled={disabled}
        value={value}
        onChange={onChange}
        size="small"
        sx={[
          {
            textAlign: "left",
            borderRadius: "0.75rem",
            "& .MuiSelect-select": {
              paddingTop: "0.6875rem",
              paddingBottom: "0.6875rem",
            },

            "&.MuiInputBase-adornedStart .MuiOutlinedInput-input": {
              marginLeft: "0.3125rem",
            },
            "&.Mui-focused fieldset": {
              borderColor: `${theme.palette.text.secondary} !important`,
            },
            "&.MuiInputBase-sizeSmall": {
              height: "3rem",
            },
            "&.MuiInputBase-sizeMedium": {
              height: "3.5rem",
            },
          },
          customInputSxProps,
        ]}
        MenuProps={{
          sx: {
            maxHeight: 400,
            "& .MuiPaper-root": {
              backgroundColor: "black",
            },
          },
        }}
      >
        {options?.map((item) => (
          <MenuItem sx={{ p: 1 }} key={item.id} value={item.id.toString()}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </Box>
  );
});

export default FormSelect;
